/**
 * App
 * ------
 * Specify vendor and app specific js files to be compiled
 */

// Vendor Requires
require('./vendor/bootstrap.min');
require('./vendor/flexMenu');
require('./vendor/imagesloaded.pkgd.min.js');
// require('./vendor/jquery.actual.min');

// Optional Vendor Requires
require('./vendor/waypoint');
require('./vendor/waypoint-animate.js');
require('./vendor/slick.min');
require('./vendor/picturefill');
// require('./vendor/jquery.validate.min');
// require('./vendor/object-visual-lock');
// require('./vendor/js.cookie');
// require('./vendor/youtube-iframe-assistant');

// App Requires
require('./app/primary-nav');
require('./app/slider-nav');
require('./app/block-animations');
require('./app/config');
require('./app/helpers');
require('./app/hero-video');
require('./app/global');
require('./app/sliders');
require('./app/scroll-to');
require('./app/video-modal');
require('./app/split-content-image-selector');
require('./app/hero-with-banner');
require('./app/screen-slider');